import { GET_ASSIGNED_EVENT_TOOLS } from 'actions/Types';
import { matchPath } from 'react-router';
import Paths from 'AppPaths';

export default (state = [], action) => {
  //If we have a match on the team or user dash, we should clear the existing team
  //before loading the next
  if (action.type === '@@router/LOCATION_CHANGE') {
    const pathName = action.payload.location.pathname;

    const teamMatch = matchPath(pathName, {
      path: Paths.TeamDash,
      exact: true
    });

    const userMatch = matchPath(pathName, {
      path: Paths.UserDash,
      exact: true
    });

    //Only clear the team if it changed
    if (teamMatch && state && teamMatch.params.teamId !== state._id) {
      return [];
    }

    if (userMatch) {
      return [];
    }
  }

  if (action.type === `${GET_ASSIGNED_EVENT_TOOLS}_SUCCESS`) {
    return action.payload;
  }

  return state;
};
